import { useCallback, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import useUpdateEffect from '../../hooks/useUpdateEffect';
import { getDeliveryFencesFile, getDeliveryFencesFileKey } from '../../services/deliveryFenceService';
import { apiParamsState } from '../../storage/app';
import { deliveryFencesGeojsonState, updatedDeliveryFencesKeyState } from '../../storage/map';

export function DeliveryFencesGeoJsonProvider() {
  const apiParams = useRecoilValue(apiParamsState);
  const setDeliveryFencesGeojson = useSetRecoilState(deliveryFencesGeojsonState);
  const updatedDeliveryFencesKey = useRecoilValue(updatedDeliveryFencesKeyState);

  const handleFileRead = useCallback(
    (event: any) => {
      const content = JSON.parse(event.target.result);
      setDeliveryFencesGeojson(content);
    },
    [setDeliveryFencesGeojson]
  );

  useEffect(() => {
    const invalid = !apiParams?.clientId || !apiParams.subClientId;
    if (invalid) return;

    const loadDeliveryFencesFile = async () => {
      const { key, error: fileKeyError } = await getDeliveryFencesFileKey(apiParams.clientId, apiParams.subClientId);
      if (!fileKeyError && key) {
        const { file, error: fileError } = await getDeliveryFencesFile(key);
        if (!fileError && file) {
          const reader = new FileReader();
          reader.onload = handleFileRead;
          reader.readAsText(file);
        } else {
          setDeliveryFencesGeojson(undefined);
        }
      } else {
        setDeliveryFencesGeojson(undefined);
      }
    };
    loadDeliveryFencesFile();
  }, [apiParams?.clientId, apiParams?.subClientId, setDeliveryFencesGeojson, handleFileRead]);

  useUpdateEffect(() => {
    if (!updatedDeliveryFencesKey) return;

    const updateDeliveryFencesFile = async () => {
      const { file, error: fileError } = await getDeliveryFencesFile(updatedDeliveryFencesKey);
      if (!fileError && file) {
        const reader = new FileReader();
        reader.onload = handleFileRead;
        reader.readAsText(file);
      } else {
        setDeliveryFencesGeojson(undefined);
      }
    };
    updateDeliveryFencesFile();
  }, [updatedDeliveryFencesKey]);

  return null;
}
